export default {
  radio: "单选",
  checkbox: "多选",
};
